import { configureStore } from "@reduxjs/toolkit";
import cartReducer from "./features/cartSlice"
import coursesReducer from "./features/coursesSlice"
import subscribedCourseReducer from "./features/subscribedCourseSlice";
 
export const store2 = configureStore({
    reducer: { 
        cart: cartReducer,
        courses: coursesReducer,
        subscribedCourses: subscribedCourseReducer,
    }
})